module.exports = __webpack_public_path__ + "img/28.70255d3c.jpg";